export const Info = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
            <circle cx="16.8398" cy="16.7222" r="16" fill="#8D6B37" />
            <circle cx="16.8398" cy="16.7222" r="12" fill="#ECC45C" />
            <rect x="15.6395" y="10.3223" width="2.4" height="8.8" rx="1.2" fill="white" />
            <rect x="15.6387" y="20.7222" width="2.4" height="2.4" rx="1.2" fill="white" />
        </svg>
    );
};
